<template lang="pug">
  .series-index.p3.md-px3b.sm-p4
    .sm-block.flex.justify-center.items-start
      //- all items (odd # items hidden on two-column)
      .p3.w-1x2.sm-p0.sm-w-full
        series-item(
        v-for="(item, index) in items",
        :class="{'sm-block hidden': index % 2 === 1}",
        v-if="item.primary.series.id",
        :key="index",
        :item="item",
        :id="item.primary.series.id",
        @click="$emit('itemClick', item.primary.series.id)")

      //- (second column off odd # items)
      .p3.w-1x2.sm-hidden
        series-item(
        v-for="(item, index) in items",
        v-if="item.primary.series.id && index % 2 === 1",
        :key="index",
        :item="item",
        :id="item.primary.series.id",
        @click="$emit('itemClick', item.primary.series.id)")
</template>

<script>
import SeriesItem from '@/components/SeriesIndex__Item'
export default {
  name: 'SeriesIndex',
  props: ['items'],
  components: { SeriesItem }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SeriesIndex.vue